import React, { useState, useEffect } from "react";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/footerInicio";
import { Row, Col, Container, Card, Button, Spinner } from "react-bootstrap";
import "../components/home.css";
import SocialBar from "../components/SocialBar";
import { Link } from "react-router-dom";
// ─── Imágenes/videos de respaldo por si la API falla ─────────────────────────
import fallbackImg from "../assets/fotos/medida.png";
import QuickLinks from "../components/QuickLinks";

// ─── Noticias (estáticas de respaldo si la API falla) ────────────────────────
import pruebaNoticia  from "../assets/fotos/12.png";
import pruebaNoticia2 from "../assets/fotos/CAYCSOL_PRUEBA.png";
import pruebaNoticia3 from "../assets/fotos/TRI.png";
import pruebaNoticia4 from "../assets/fotos/Congreso2025.png";

// ─── URL base de la API (ajusta el puerto si lo cambiaste en server.js) ────────
const API_URL = "https://facach.coop.hn/api";



const noticiasFallback = [
  { id: null, imagen: pruebaNoticia,  resumen: "FACACH y DGRV llevaron a cabo el foro 'El Rol de Las Cooperativas en el Desarrollo de la Mujer Hondureña.'" },
  { id: null, imagen: pruebaNoticia2, resumen: "Cooperativa CAYCSOL, Ltda. inaugura su nueva oficina en Jutiapa, Atlántida" },
  { id: null, imagen: pruebaNoticia3, resumen: "FACACH llevo a cabo el Encuentro Tripartito 2025" },
  { id: null, imagen: pruebaNoticia4, resumen: "FACACH llevo a cabo el Congreso Cooperativo 2025" },
];

// ─────────────────────────────────────────────────────────────────────────────
const Home = () => {
  // Estado del landing dinámico
  const [landingData, setLandingData] = useState(null);
  const [loading, setLoading]         = useState(true);
  const [noticias, setNoticias]        = useState(noticiasFallback);

  // ── Fetch al montar el componente ─────────────────────────────────────────
  useEffect(() => {
    // Fetch landing (imágenes y videos)
    const fetchLanding = async () => {
      try {
        const res = await fetch(`${API_URL}/landing`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok) setLandingData(json.data);
      } catch (err) {
        console.error("Error cargando landing:", err.message);
      } finally {
        setLoading(false);
      }
    };

    // Fetch noticias
    const fetchNoticias = async () => {
      try {
        const res = await fetch(`${API_URL}/news?page=1&limit=4`);
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        if (json.ok && json.data.length > 0) {
          // Mapear al formato que usa el template
          const mapped = json.data.map(n => ({
            id:     n.id,
            imagen: n.image_url,
            resumen: n.summary || n.title,
            titulo: n.title,
            slug:   n.slug,
          }));
          setNoticias(mapped);
        }
        // Si no hay noticias publicadas, se queda el fallback
      } catch (err) {
        console.error("Error cargando noticias:", err.message);
        // Se queda el fallback automáticamente
      }
    };

    fetchLanding();
    fetchNoticias();
  }, []);

  // ── Helpers para obtener URLs con fallback ────────────────────────────────
  const getSlotUrl = (code) =>
    landingData?.slots?.[code]?.url || fallbackImg;

  const getSlotAlt = (code) =>
    landingData?.slots?.[code]?.alt_text || "Imagen FACACH";

  const getVideoUrl = (code) =>
    landingData?.videos?.[code]?.url || null;

  const getVideoLabel = (code) =>
    landingData?.videos?.[code]?.label || "";

  // ── Loading spinner ───────────────────────────────────────────────────────
  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "100vh" }}
      >
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  // ─────────────────────────────────────────────────────────────────────────
  return (
    <>
      {/* Barra de Navegación */}
      <NavbarFacach />

      {/* ── Fotos de Eventos (imágenes dinámicas desde landing_slot) ───────── */}
      <Row className="galeria-eventos">
        <Col md={8}>
          <div className="imagen-grande">
            <img
              src={getSlotUrl("LEFT_LARGE")}
              alt={getSlotAlt("LEFT_LARGE")}
              className="img-fluid imagen-ajustada"
            />
          </div>
        </Col>
        <Col md={4}>
          <div className="imagen-pequena mb-3">
            <img
              src={getSlotUrl("RIGHT_TOP")}
              alt={getSlotAlt("RIGHT_TOP")}
              className="img-fluid imagen-ajustada"
            />
          </div>
          <div className="imagen-pequena">
            <img
              src={getSlotUrl("RIGHT_BOTTOM")}
              alt={getSlotAlt("RIGHT_BOTTOM")}
              className="img-fluid imagen-ajustada"
            />
          </div>
        </Col>
      </Row>

      {/* ── Banner Aniversario (video dinámico desde landing_video → code: anniversary) */}
      <div className="banner-1500x400 mt-4 mb-4">
        {getVideoUrl("anniversary") ? (
          <video
            className="banner-video"
            src={getVideoUrl("anniversary")}
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            poster="/images/banner-poster.jpg"
            title={getVideoLabel("anniversary")}
          />
        ) : (
          // Fallback al video local si la API no responde
          <video
            className="banner-video"
            src="/videos/ANIVERSARIO.mp4"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            poster="/images/banner-poster.jpg"
          />
        )}
      </div>

      {/* ── Carrusel Afiliados (video dinámico desde landing_video → code: coops) */}
      <div className="mt-4">
        <h2 className="text-center mt-4 mb-4">NUESTROS AFILIADOS</h2>
        <div className="collage-rotativo mt-4 mb-4">
          <video
            src={getVideoUrl("coops") || "/videos/video.mp4"}
            autoPlay
            loop
            muted
            width="100%"
            title={getVideoLabel("coops")}
            style={{
              display: "block",
              borderRadius: "8px",
              marginLeft: "4px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            }}
          />
        </div>
      </div>

      {/* ── Noticias (estáticas por ahora) ──────────────────────────────────── */}
      <Container className="my-5">
        <h2 className="text-center mb-4">NOTICIAS | MOVIMIENTO COOPERATIVO</h2>
        <Row>
          {noticias.map((noticia, index) => (
            <Col key={index} md={3}>
              <Card
                className="mb-4"
                style={{
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                  height: "350px",
                }}
              >
                <Card.Img variant="top" src={noticia.imagen} />
                <Card.Body>
                  <Card.Text>{noticia.resumen}</Card.Text>
                </Card.Body>
                <Card.Footer className="bg-transparent border-0 pt-0 pb-3">
                  <Button
                    as={Link}
                    to={`/noticias/${noticia.id}`}
                    variant="outline-primary"
                    size="sm"
                    className="card-news-btn"
                    aria-label={`Explora la Noticia Completa: ${noticia.titulo || "noticia"}`}
                    style={{
                      background: "white",
                      color: "#252A58",
                      border: "0px solid #252A58",
                      opacity: "0.90",
                    }}
                  >
                    Explora la Noticia Completa 
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          ))}
        </Row>

        <div className="boton-centro">
          <Button variant="primary" as={Link} to="/Noticias" className="w-20">
            Ver Más
          </Button>
        </div>

        <QuickLinks/>

        <SocialBar position="right" top="35%" size={42} rounded={true} />
      </Container>

      <FooterFacach />
    </>
  );
};

export default Home;